/* eslint-disable */
import React, { Children, Component } from 'react'
import PropTypes from 'prop-types'
import Media from 'react-media'
import SectionNavItem from './SectionNavItem'
import { NavSelect } from 'components/nav-select'

import styled from '@emotion/styled'

const StyledUl = styled('ul')`
  height: 100%;
  list-style-type: none;
  margin: 0;
  padding: 0 16px;
`
const StyledUlForMobile = styled('ul')`
  height: 100%;
  list-style-type: none;
  margin: 0;
  padding: 0 16px;
  display:flex;

  li{
    width:max-content;
  }
`

class SectionNavList extends Component {
  getNavOptions = () => {
    const { children, location } = this.props
    let options = []
    let value = ''
    Children.forEach(children, child => {
      if (child?.type.displayName === 'SectionNavItem') {
        if (child.props.to === location.pathname) {
          value = child.props.children
        } else {
          const { children, ...props } = child.props
          options.push({ name: children, ...props })
        }
      }
    })
    return { value, options }
  }

  render() {
    return (
      <Media query={`(min-width: ${600 / 16}em)`}>
        {largeScreen =>
          largeScreen ? (
            <StyledUl>{this.props.children}</StyledUl>
          ) : (
            <StyledUlForMobile>{this.props.children}</StyledUlForMobile>
          )
        }
      </Media>
    )
  }
}

SectionNavList.propTypes = {
  children: PropTypes.arrayOf(PropTypes.element).isRequired,
  location: PropTypes.object.isRequired,
}

export default SectionNavList
